import React from 'react';
import ManualClassroomsProvider from '@teetsh/app/src/containers/App/context/ClassroomsContext/ManualClassroomsContext';
import tw from 'twin.macro';
import { ReunionSearchResult } from '@teetsh/app/src/containers/Search/types';
import { Tag } from '@teetsh/app/src/components/Tag';
import HtmlViewer from '@teetsh/app/src/components/HtmlViewer';
import { getSeanceAttachmentUrl } from '@teetsh/app/src/utils/urls';
import { format } from '@teetsh/app/src/utils/time/format';
import { getDurationInHoursAndMinutesBetween } from '@teetsh/app/src/utils/time';
import { DocumentArrowDownIcon as DocumentDownload } from '@heroicons/react/24/outline';
import { Bars3BottomLeftIcon as MenuAlt2 } from '@heroicons/react/20/solid';
import { PaperClipIcon as PaperClip } from '@heroicons/react/24/outline';
import Line from '@teetsh/app/src/containers/Search/components/Line';
import addMinutes from '@teetsh/app/src/utils/time/addMinutes';
import _isEmpty from 'lodash-es/isEmpty';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';

interface Props {
  reunion: ReunionSearchResult;
}

export function ReunionPreview(props: Props) {
  const { t } = useTranslation();
  const { reunion } = props;
  const { locale } = useUser();

  const formatedDuration = getDurationInHoursAndMinutesBetween(
    reunion.date,
    addMinutes(reunion.date, reunion.lasting),
  );
  return (
    <div tw="p-6">
      <ManualClassroomsProvider classrooms={[]}>
        <div>
          <div tw="flex items-center">
            <div tw="text-xl font-bold flex-grow">{reunion.name}</div>
            {reunion.categoryName && (
              <div tw="text-right shrink-0">
                <Tag color={reunion.categoryColor}>{reunion.categoryName}</Tag>
              </div>
            )}
          </div>
          <div tw="space-x-3 text-sm font-normal">
            <span>{format(reunion.date, locale, 'eeee dd MMMM yyyy')}</span>
            <span>
              {format(reunion.date, locale, t('common:time.pattern_HH_mm'))} -{' '}
              {format(
                addMinutes(reunion.date, reunion.lasting),
                locale,
                t('common:time.pattern_HH_mm'),
              )}
              <span tw="ml-2 text-muted">({`${formatedDuration}`})</span>
            </span>
          </div>
        </div>
        <div tw="border-b w-full my-4" />

        <div tw="grid grid-cols-12 gap-x-2 gap-y-4">
          {(reunion?.attachments || []).length > 0 && (
            <Line icon={PaperClip}>
              <div tw="space-x-2">
                {reunion.attachments.map(a => (
                  <a
                    onClick={e => e.stopPropagation()}
                    href={getSeanceAttachmentUrl(
                      a.s3Path,
                      a.s3Filename,
                      a.label,
                    )}
                    rel="noreferrer noopener"
                    css={[
                      tw`text-neutral-moderate hover:underline break-all font-medium`,
                    ]}
                    target="_blank"
                  >
                    <div
                      key={a.label}
                      tw="rounded-xl bg-neutral-quiet hover:bg-neutral-moderate p-2 py-1 inline-flex text-xs items-center cursor-pointer"
                    >
                      <DocumentDownload tw="h-4 w-4 mr-1 text-neutral-moderate" />
                      {a.label}
                    </div>
                  </a>
                ))}
              </div>
            </Line>
          )}

          {!_isEmpty(reunion.description) && (
            <Line icon={MenuAlt2}>
              <HtmlViewer onChange={() => {}} text={reunion.description} />
            </Line>
          )}
        </div>
      </ManualClassroomsProvider>
    </div>
  );
}
